export default {
  exitPromise: null,
  resolveLogin() {},
  resolveLoginFinalization() {},
  shouldFocusOnPostMatch() {
    return true;
  },
};
